import { Link } from "react-router-dom";

export default function ScoopCta() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-8">
      <div className="relative overflow-hidden rounded-xl bg-gradient-to-r from-primary-700 to-primary-600 px-6 md:px-12 py-10 md:py-14">
        <div className="absolute -right-10 -top-10 w-56 h-56 rounded-full bg-accent-500/20 blur-2xl"></div>
        <div className="absolute right-16 bottom-0 text-background-50/10">
          <i className="ri-newspaper-line text-[140px] leading-none"></i>
        </div>
        <div className="relative max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-accent-300 text-sm mb-3">
            <i className="ri-mail-send-line"></i>爆料投稿通道
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-black text-background-50 leading-snug">
            掌握第一手猛料？<br className="sm:hidden" />欢迎向每日爆料提供线索
          </h2>
          <p className="mt-3 text-background-100/90 leading-relaxed">
            无论你身处事件现场，还是知道行业内幕，都可以通过投稿邮箱与我们联系。我们将对每一条线索认真核实、择优刊发，并对爆料人信息严格保密。
          </p>
          <div className="mt-6 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <a
              href="mailto:baoliao@meiribaoliao.cn"
              className="inline-flex items-center justify-center gap-2 bg-background-50 text-primary-700 font-medium px-6 py-3 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-mail-line text-lg"></i>baoliao@meiribaoliao.cn
            </a>
            <Link
              to="/about#contact"
              className="inline-flex items-center justify-center gap-2 bg-accent-500 text-foreground-950 font-medium px-6 py-3 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-customer-service-2-line text-lg"></i>商务合作与咨询
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}